import React from 'react'
import PropTypes from 'prop-types'

import MyProptypes from '@global/propTypes'
import { SIZE } from '@global/fonts'

import Icon from '@components/icon'
import { Text } from '@components/texts'

import { Wrapper, Img } from './styles'

export const Bit = ({ icon, text, color, disabled, onClick, image, alt }) => (
  <Wrapper onClick={onClick} color={color} tabIndex='-1' disabled={disabled}>
    {icon && <Icon name={icon} size='large' disabled={disabled} />}
    {text && <Text text={text} size='large' disabled={disabled} />}
    {image && <Img src={image} alt={alt} size={SIZE.XLARGE} disabled={disabled} />}
  </Wrapper>
)

Bit.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  color: MyProptypes.color,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  image: PropTypes.string,
  alt: PropTypes.string
}

export default Bit
